module.exports = __webpack_public_path__ + "img/LOGO_SVG.33a39a7d.svg";